import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Dropdown } from 'react-bootstrap';
import i18next from '../../i18n.js';
import { urls, vacationTypes } from '../../constants.js';
import { unknownErrorMessageDialog } from '../ModalDialog.js';
import moment from 'moment';
import { Table } from '../table/Table.js';
import { isMobile } from '../helpers/HelperFunctions.js';

const columnsSettings = [
    {
        "id": "0",
        "name": "UserName",
        "CanSort": true,
        "headerName": i18next.t("calendar.employee"),
        "type": "string"
    },
    {
        "id": "1",
        "name": "MainCount",
        "CanSort": true,
        "headerName": i18next.t("vacationKinds.main"),
        "type": "string"
    },
    {
        "id": "2",
        "name": "AdditionalChildcareCount",
        "CanSort": true,
        "headerName": i18next.t("vacationKinds.additionalChildcare"),
        "type": "string"
    },
    {
        "id": "2",
        "name": "ChaesCount",
        "CanSort": true,
        "headerName": i18next.t("vacationKinds.chaes"),
        "type": "string"
    },
    {
        "id": "2",
        "name": "UbdCount",
        "CanSort": true,
        "headerName": i18next.t("vacationKinds.ubd"),
        "type": "string"
    }
]

const SchedulePage = () => {
    const nowDate = new Date();
    const currentDays = Array.from({ length: new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0).getDate() }, (_, i) => i + 1);
    const navigate = useNavigate();
    const months = Array.from({ length: 12 }, (_, i) => i);
    const [days, setDays] = useState(currentDays);
    const [holidays, setHolidays] = useState(currentDays.filter(day => [0, 6].includes(new Date(nowDate.getFullYear(), nowDate.getMonth(), day).getDay())));
    const years = Array.from({ length: nowDate.getFullYear() - 2024 + 2 }, (_, i) => i + 2024);
    const [year, setYear] = useState(nowDate.getFullYear());
    const [month, setMonth] = useState(nowDate.getMonth());
    const [showOrientationMessage, setShowOrientationMessage] = useState(false);
    const [loading, setLoading] = useState(false);
    const [vacationIntervals, setVacationIntervals] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [vacationType, setVacationType] = useState(null);
    const [users, setUsers] = useState([]);
    const [showUserSelect, setShowUserSelect] = useState(false);

    const fetchResults = useRef({});
    const userSelectRef = useRef(null);

    const onYearChanged = (val) => setYear(val);
    const onMonthChanged = (val) => setMonth(val);
    const onVacationTypeChanged = (val) => setVacationType(val);
    const onCloseBtnClick = () => {
        const urlParams = new URLSearchParams(document.location.search);
        const returnParam = urlParams.get('return');
        if (returnParam) {
            navigate(returnParam);
        }
        else {
            navigate(urls.calendarPage);
        }
    }
    const onUserChanged = (val) => {
        if (!val) {
            setSelectedUsers([]);
        }
        else {
            setSelectedUsers(selectedUsers.includes(val) ? selectedUsers.filter(u => u !== val) : [...selectedUsers, val])
        }
    }

    const onSelectAllUsers = (allSelected) => {
        if (allSelected) {
            setSelectedUsers([]);
        }
        else {
            setSelectedUsers(users);
        }
    }

    useEffect(() => {
        onResize();
        window.addEventListener('resize', onResize);
        document.addEventListener('click', onDocumentClick);

        return () => {
            window.removeEventListener('resize', onResize);
            document.removeEventListener('click', onDocumentClick);
        }
    }, []);

    useEffect(() => {
        loadShedule();
        const days = Array.from({ length: new Date(year, parseInt(month) + 1, 0).getDate() }, (_, i) => i + 1);
        const holidays = days.filter(day => [0, 6].includes(new Date(year, month, day).getDay()))
        setDays(days);
        setHolidays(holidays);

    }, [year, month]);

    const loadShedule = () => {
        const processResult = (scheduleInfo) => {
            const intervals = [...vacationIntervals];
            scheduleInfo.vacations.forEach(vacation => {
                const startDate = moment(vacation.claimDateStart, 'DD.MM.YYYY').toDate();
                const endDate = moment(vacation.claimDateEnd, 'DD.MM.YYYY').toDate();
                if (!intervals.some(i => i.userName === vacation.creator && i.startDate === startDate && i.endDate === endDate)) {
                    intervals.push({
                        userName: vacation.creator,
                        startDate: startDate,
                        endDate: endDate,
                    });
                }
            });

            setVacationIntervals(intervals);
            setUsers(scheduleInfo.subordinateUsers);
            setSelectedUsers(scheduleInfo.subordinateUsers);
        }

        if (!loading) {
            setLoading(true);
            if (fetchResults.current[year + month]) {
                processResult(fetchResults.current[year + month]);
            }
            else {
                const body = {
                    year: year,
                    month: parseInt(month) + 1
                }
                fetch('/api/Home/GetScheduleInfo', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body)
                })
                    .then(async (response) => {
                        if (response.ok) {
                            const scheduleInfo = await response.json();
                            processResult(scheduleInfo);
                            fetchResults.current[year + month] = scheduleInfo;
                        }
                        else if (response.status !== 500 && response.status !== 401) {
                            unknownErrorMessageDialog();
                        }
                        setLoading(false);
                    })
                    .catch(err => {
                        console.error(err);
                        unknownErrorMessageDialog();
                        setLoading(false);
                    });
            }
        }
    }

    const onResize = () => {
        const isPortrait = window.matchMedia("(orientation: portrait)").matches;
        const isMobileDevice = window.innerWidth <= 760;

        setShowOrientationMessage(isMobileDevice && isPortrait);
    }

    const onDocumentClick = (e) => {
        if (userSelectRef.current && e.target !== userSelectRef.current && !userSelectRef.current.contains(e.target)) {
            setShowUserSelect(false);
        }
    }

    const isVacation = (userName, dayNum) => {
        const date = new Date(year, month, dayNum);
        return vacationIntervals.find(item => vacationType !== vacationTypes.businessTrip && item.userName === userName && date >= item.startDate && date <= item.endDate) != null;
    }

    const getShortName = (fullName) => {
        const parts = fullName.split(' ');
        return `${parts[0]} ${parts[1][0]}.`;
    }

    const getLeftDayRows = () => {
        return users.filter(u => selectedUsers.length === 0 || selectedUsers.includes(u)).map((user, i) => {
            return {
                columns: {
                    UserName: user.fullName,
                    MainCount: user.vacationLimits?.unusedVacationDaysMain,
                    AdditionalChildcareCount: user.vacationLimits?.unusedVacationDaysChild,
                    ChaesCount: user.vacationLimits?.unusedVacationDaysChaes,
                    UbdCount: user.vacationLimits?.unusedVacationDaysUBD
                }
            }
        });
    }

    if (showOrientationMessage) {
        return <div className='schedule-page'>
            <div className='schedule-header'>
                <Button className='header-btn close' onClick={onCloseBtnClick} />
            </div>
            <div className='schedule-content'>
                <div className='orientation-msg'>
                    {i18next.t('calendar.orientationMsg')}
                </div>
            </div>
        </div>
    }
    else {
        return <div className='schedule-page'>
            <div className='schedule-header'>
                <div className='schedule-filter'>
                    <Dropdown>
                        <Dropdown.Toggle variant='light'>
                            <div className='toggle-content'>{year}</div>                            
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {years.map((val) => <Dropdown.Item className={year === val ? 'selected' : ''} onClick={() => onYearChanged(val)}>{val}</Dropdown.Item>)}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                        <Dropdown.Toggle variant='light'>
                            <div className='toggle-content'>{i18next.t(`calendar.months.${month}`)}</div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {months.map((val) => <Dropdown.Item className={month === val ? 'selected' : ''} onClick={() => onMonthChanged(val)}>{i18next.t(`calendar.months.${val}`)}</Dropdown.Item>)}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown className='multiple' show={showUserSelect} ref={userSelectRef} >
                        <Dropdown.Toggle variant='light' onClick={() => setShowUserSelect(!showUserSelect)}>
                            <div className='toggle-content'>{selectedUsers.length === 0 || selectedUsers.length === users.length ? i18next.t(`calendar.allUsers`) : selectedUsers.map(u => getShortName(u.fullName)).join(', ')}</div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item className={selectedUsers?.length === users?.length ? 'selected' : ''} onClick={(e) => { e.preventDefault(); onSelectAllUsers(selectedUsers?.length === users?.length) }}><div className='item-content'>{i18next.t('all')}</div></Dropdown.Item>
                            {users.map((val) => <Dropdown.Item className={selectedUsers.includes(val) ? 'selected' : ''} onClick={(e) => { e.preventDefault(); onUserChanged(val); }}><div className='item-content'>{val.fullName}</div></Dropdown.Item>)}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                        <Dropdown.Toggle variant='light'>
                            <div className='toggle-content'>{vacationType ? i18next.t(`vacationTypes.${vacationType}`) : i18next.t(`calendar.allTypes`)}</div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item className={!vacationType ? 'selected' : ''} onClick={() => onVacationTypeChanged('')}>{i18next.t(`calendar.allTypes`)}</Dropdown.Item>
                            {Object.keys(vacationTypes).map((key) => <Dropdown.Item className={vacationType === key ? 'selected' : ''} onClick={() => onVacationTypeChanged(key)}>{i18next.t(`vacationTypes.${key}`)}</Dropdown.Item>)}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <Button className='header-btn close' onClick={onCloseBtnClick} />
            </div>
            <div className='schedule-content'>
                <div className='users'>
                    <div key='-1'>{i18next.t('calendar.employee')}</div>
                    {users.filter(u => selectedUsers.includes(u)).map((user, i) => {
                        return <div key={i}>{getShortName(user.fullName)}</div>
                    })}
                </div>
                <div className='board'>
                    <div className='schedule-row' key='-1'>
                        {days.map((day, i) => <div className={'schedule-col' + (holidays.includes(i + 1) ? ' holiday' : '')} key={i}>{day}</div>)}
                    </div>
                    {users.filter(u => selectedUsers.includes(u)).map((user, i) => <div className='schedule-row' key={i} >
                        {days.map((_, j) => <div className={'schedule-col' + (holidays.includes(j + 1) ? ' holiday' : '') + (isVacation(user.userName, j + 1) ? ' vacation' : '')} key={j} />)}
                    </div>)}
                </div>
            </div>
            {!isMobile() && selectedUsers?.length > 0 && <div className='left-datys-content'>
                <div className='left-datys-content-label'>{i18next.t('other.leftDaysTableTitle')}</div>
                <Table columns={columnsSettings} items={getLeftDayRows()} sortBy="UserName" isDesk={false} />
            </div>}
            {!isMobile() && selectedUsers?.length === 0 && users?.length > 0 && <div className='left-datys-content'>
                <div className='left-datys-content-label'>{i18next.t('other.usersNotSelected')}</div>
            </div>}
        </div>
    }
}

export default SchedulePage;